export const GameType = {
  ROLLS: 'rolls',
  JETTON: 'jetton',
  MINES: 'mines',
  BALLOON: 'balloon',
  GLOBAL: 'global',
} as const;

export type GameTypeValue = (typeof GameType)[keyof typeof GameType];

export const STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  USER_PREFERENCES: 'user_preferences',
};

export const ROUTES = {
  HOME: '/',
  GAMES: '/games',
  PROFILE: '/profile',
  ROLLS: '/rolls',
  JETTON: '/jetton',
  SHOP: '/shop',
  LEADERBOARD: '/leaderboard',
  HISTORY: '/history',
  JETTON_HISTORY: '/jetton-history',
  MINES: '/mines',
  BALLOON: '/balloon',
};

export const GAME_ROUTES = [ROUTES.ROLLS, ROUTES.JETTON, ROUTES.MINES, ROUTES.BALLOON];

export const GAME_CONFIG = {
  ROLLS: {
    MIN_BET: 0.1,
    MAX_BET: 100,
    COUNTDOWN_SECONDS: 10,
    SPIN_DURATION: 5,
    PLATFORM_FEE_PERCENT: 0.05,
  },
  JETTON: {
    MIN_BET: 0.1,
    MAX_BET: 5,
    MAX_PAYOUT: 50,
    HOUSE_EDGE: 0.03,
    GROWTH_RATE: 0.00006,
  },
  MINES: {
    MIN_BET: 0.1,
    MAX_BET: 5.0,
    HOUSE_EDGE: 0.03,
  },
};

export const PLAYER_COLORS = [
  '#8b5cf6', // purple
  '#ef4444', // red
  '#22c55e', // green
  '#3b82f6', // blue
  '#f59e0b', // amber
  '#ec4899', // pink
  '#06b6d4', // cyan
  '#f97316', // orange
  '#14b8a6', // teal
  '#a855f7', // violet
  '#64748b', // slate
  '#dc2626', // red-dark
  '#16a34a', // green-dark
  '#2563eb', // blue-dark
  '#d97706', // amber-dark
  '#db2777', // pink-dark
  '#0891b2', // cyan-dark
  '#ea580c', // orange-dark
  '#0d9488', // teal-dark
  '#9333ea', // purple-dark
  '#84cc16', // lime
  '#e11d48', // rose
  '#0ea5e9', // sky
  '#c2410c', // orange-deep
  '#059669', // emerald
];
